<template>
  <tr>
    <td></td>
    <td class="society-group">
      <ul class="society">
        <li><i class="circle red"></i>SARL SpiderMan (SP)</li>
        <li>Spidermobile, Spider</li>
      </ul>
    </td>
    <td class="v-align-middle">
      <ul class="name">
        <li>Bruce Wayne</li>
        <li>Gérant</li>
      </ul>
    </td>
    <td class="v-align-middle">
      <ul class="contract">
        <li><span class="sdm micrologo"></span>Domiciliation</li>
        <li>Mise à dispo / BAL 156</li>
      </ul>
    </td>
    <td>
      <ul>
        <li>Fait le : 12/04/2016</li>
        <li>Par : Jean Bon</li>
      </ul>
    </td>
    <td class="v-align-middle">
      <ul class="options">
        <li><i class="fa fa-check"></i>Colis</li>
        <li><i class="fa fa-close"></i>Procuration</li>
        <li><i class="fa fa-close"></i>Notif. si LR</li>
        <li><i class="fa fa-check"></i>Courrier bloqué</li>
      </ul>
    </td>
    <td>
      <span>Incomplet</span>
    </td>
    <td>
      <span>En attente de validation</span>
    </td>
    <td class="v-align-middle">
      <button class="btn btn-default btn-sm m-t-10">Détails</button>
    </td>
  </tr>
</template>

<script type="text/babel">
  export default {}
</script>

<style lang="scss" scoped>
  @import '~pages_sass/_var.scss';

  td {
    &:first-child {
      &::before {
        display: none !important;
      }
    }
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .society-group {
    .society {
      li {
        &:first-child {
          text-transform: uppercase;
        }
      }
    }
  }

  .society, .name {
    li {
      &:last-child {
        font-size: 0.7rem;
      }
    }
  }

  .contract {
    font-size: 0.7rem;
    position: relative;
    overflow: visible;
    .sofradom {
      background: url('#{$base-img-url}/brand-logos/logo-sofradom.png') no-repeat 50% / contain;
    }
    .sdm {
      background: url('#{$base-img-url}/brand-logos/logo-sdm.jpg') no-repeat 50% / contain;
    }
    .abc {
      background: url('#{$base-img-url}/brand-logos/logo-abc.jpg') no-repeat 50% / contain;
    }
    .micrologo {
      position: absolute;
      font-size: 1rem;
      left: -30px;
      top: 2px;
      width: 25px;
      height: 20px;
    }
  }

  .options {
    li {
      font-size: 0.6rem;
      line-height: 1rem;
      i {
        &.fa-close {
          font-size: 0.7rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/DomiciliationContractsList/Item.vue